import { render, staticRenderFns } from "./DatoI18nText.vue?vue&type=template&id=179db59b&"
import script from "./DatoI18nText.vue?vue&type=script&lang=js&"
export * from "./DatoI18nText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports